import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { SurveyProvider } from '../../providers/survey/survey';
import { SurveyDetailPage } from '../survey-detail/survey-detail';
import { UtilService } from '../../services/util';
import { Storage } from '@ionic/storage';
import { ValueTransformer } from '@angular/compiler/src/util';
import { TranslateService } from '@ngx-translate/core';
import { ToastProvider } from '../../providers/toast/toast';

@IonicPage()
@Component({
  selector: 'page-survey',
  templateUrl: 'survey.html',
})
export class SurveyPage {

  showData = false;
  activeSurveys = [];
  enableRefresh = true;
  user_tenant =false;
  selRegistrationLogin  : any;
  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private translate: TranslateService,
    private ref : ChangeDetectorRef,
    private surveyProvider: SurveyProvider,
    private util:UtilService,
    private toast: ToastProvider,
    private storage: Storage) {

      this.selRegistrationLogin = localStorage.getItem('signup_login')

      if(this.selRegistrationLogin){
        this.showData = true
        this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
      }
else{
      this.storage.get("loginDetails").then(val => {
        if(val.tenant){
          this.user_tenant = val.tenant;
        }
      });
      surveyProvider.getActiveSurvey().then(val => {
        this.showData = true;
        this.activeSurveys = val;
        this.ref.detectChanges();
 		  });
      surveyProvider.getAnswerMaster();
    }
  }

  gotoSurvey(item){console.log(item,item.url)
    this.navCtrl.push(SurveyDetailPage, {
      id: item.survey_id,
      name: item.name,
      description: item.description,
      show_tenant : item.isVisible,
      attachment : item.url
    });
  }

  doRefresh(refresher) {
    if(this.selRegistrationLogin){
      setTimeout(() => {
        this.showData = true;
        refresher.complete() 
        },2000)
    }
    else{
    this.surveyProvider.getActiveSurvey().then(val => {
      this.showData = true;
      this.activeSurveys = val;
      this.ref.detectChanges();
      refresher.complete();
   });
   this.surveyProvider.getAnswerMaster();
  }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SurveyPage');
  }

}





// WEBPACK FOOTER //
// ./src/pages/survey/survey.ts